import { FC } from 'react';

import { Carousel, CarouselProps } from 'antd';
import cs from 'classnames';

import { ReactComponent as ArrowCircleLeft } from 'assets/icons/arrowCircleLeft.svg';
import { ReactComponent as ArrowCircleRight } from 'assets/icons/arrowCircleRight.svg';

interface ResponsiveCarouselProps extends CarouselProps {
  className?: string;
}

const ResponsiveCarousel: FC<ResponsiveCarouselProps> = ({
  children,
  className,
  ...carouselProps
}) => {
  return (
    <Carousel
      className={cs('responsive-carousel', className)}
      arrows
      infinite
      slidesToShow={2}
      dots={false}
      nextArrow={<ArrowCircleRight />}
      prevArrow={<ArrowCircleLeft />}
      {...carouselProps}
    >
      {children}
    </Carousel>
  );
};

export default ResponsiveCarousel;
